
























































import Vue from 'vue';

import { Outlet, Retailer } from '@/core/entity';

import { getOutletQL } from './graphql';

export default Vue.extend({
  props: {
    loading: Boolean as () => boolean,
    outletId: String as () => string | null,
  },

  apollo: {
    outlet: {
      query: getOutletQL,
      variables() {
        return { id: this.outletId };
      },
      skip() {
        // outlet id can be null (when creating new) or undefined (when dismissed)
        return !this.outletId;
      },
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    return {
      form: this.$form.createForm(this),
      outlet: null as Outlet | null,
    };
  },

  computed: {
    submitText(): string {
      return this.outletId ? 'Update' : 'Create';
    },
  },

  watch: {
    outletId(newVal: string | null) {
      this.outlet = null;
    },
    outlet(newVal: Outlet | null) {
      this.form.setFieldsValue({
        name: newVal ? newVal.name : '',
        address: newVal ? newVal.address : '',
        gps: newVal ? `${newVal.lat},${newVal.lon}` : '',
      });
    },
  },

  methods: {
    handleSubmit() {
      this.form.validateFields((errors: Error[], val: any) => {
        if (errors === null) {
          const { name, address, gps } = val;
          const [lat, lon] = (gps as string)
            .split(',')
            .map((s) => s.trim())
            .map((s) => parseFloat(s));

          this.$emit('save', {
            name,
            address,
            lat,
            lon,
          });
        }
      });
    },
  },
});
